import { render, staticRenderFns } from "./Chat copy.vue?vue&type=template&id=9488dc10&scoped=true"
import script from "./Chat copy.vue?vue&type=script&lang=js"
export * from "./Chat copy.vue?vue&type=script&lang=js"
import style0 from "./Chat copy.vue?vue&type=style&index=0&id=9488dc10&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9488dc10",
  null
  
)

export default component.exports